import React from "react";

import { useGetSuppressionBySuppressionIdQuery } from "@tiny/api";
import {
  useRefreshRegister,
  useRefresh,
} from "@tiny/components/src/RefreshProvider";
import { format } from "date-fns";

const DATE_FORMAT = "d MMM, yy - h:mm aa";

export function useSuppressionSourceDetails(suppressionIdProp?: string) {
  const { refresh } = useRefresh();

  const { suppressionId } =
    useSuppressionSourceDetailsParams(suppressionIdProp);

  const {
    data: suppressionDetails,
    refetch: refetchSuppressionDetails,
    isLoading: isSegmentLoading,
  } = useGetSuppressionBySuppressionIdQuery(suppressionId);

  useRefreshRegister(async () => {
    await refetchSuppressionDetails();
  });

  const enableEdit = React.useMemo(() => {
    return true;
  }, []);

  const subtitle = React.useMemo(() => {
    if (!suppressionDetails?.createdAt) {
      return null;
    }
    const formattedDate = format(
      new Date(suppressionDetails?.createdAt),
      DATE_FORMAT
    );
    return `Created: ${formattedDate}`;
  }, [suppressionDetails?.createdAt]);

  return {
    suppressionDetails,
    suppressionId,
    refetchSuppressionDetails,
    enableEdit,
    subtitle,
    isSegmentLoading,
  };
}

function useSuppressionSourceDetailsParams(suppressionIdProp?: string) {
  // suppressionId arrives via props from the app's route layer.
  const suppressionId = suppressionIdProp;

  return {
    suppressionId: suppressionId!,
  };
}
